module.exports = __webpack_public_path__ + "img/ashe1.2b8eb84a.png";